/* Speed (2026-10): no ScrollSmoother (native scrolling), header pin kept,
   reveal animation only for blocks still outside the viewport when JS is ready,
   ScrollTrigger-based parallax for [data-speed] backgrounds (was a Smoother effect). */
let smoother;
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  window.scroll_trigger_menu = window.innerWidth >= 990
    ? ScrollTrigger.create({ trigger: "nav.header__inline-menu", start: "top top", end: "+=99999", pin: true, pinSpacing: false,
        onEnter(e) { e.trigger.classList.add("custom-sticky-menu"); }, onLeaveBack(e) { e.trigger.classList.remove("custom-sticky-menu"); } })
    : ScrollTrigger.create({ trigger: "sticky-header.header-wrapper", start: "top top", end: "+=99999", pin: true, pinSpacing: false, pinType: "fixed",
        onEnter(e) { e.trigger.classList.add("mobile-custom-sticky-menu"); }, onLeaveBack(e) { e.trigger.classList.remove("mobile-custom-sticky-menu"); } });
  gsap.utils.toArray(".parallax-bg[data-speed]").forEach(el => {
    const sp = parseFloat(el.getAttribute("data-speed"));
    if (isNaN(sp) || sp === 1) return;
    gsap.to(el, { yPercent: (1 - sp) * -40, ease: "none", scrollTrigger: { trigger: el.parentElement, start: "top bottom", end: "bottom top", scrub: true } });
  });
  const vh = window.innerHeight;
  gsap.utils.toArray("[load-animation]").forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.bottom > 0 && r.top < vh * 0.87) return; // already on screen: keep it visible, no flash
    const d = el.getAttribute("load-delay"); const o = d ? parseFloat(d) / 1e3 : 0;
    gsap.fromTo(el, { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, duration: .3, delay: o, ease: "none",
      scrollTrigger: { trigger: el, start: "top 87%", end: "bottom 60%", toggleActions: "play none none none", scrub: false } });
  });
});
